/**
 * @desc: Copied from https://git.perkbox.io/backend-services/identity-v2/blob/master/internal/errorLib/codes.go
 */
enum Team {
  TeamNotFoundErr = "PBIDETeamNotFound",
  TeamDoesNotBelong = "PBIDETeamDoesNotBelong",
  PublicNameAlreadyExists = "PBIDEPublicNameAlreadyExists",
  PublicNameTooShort = "PBIDEPublicNameTooShort",
  PublicNameTooLong = "PBIDEPublicNameTooLong",
  PublicNameInvalid = "PBIDEPublicNameInvalid",
  TenantCannotBeChanged = "PBIDETenantCannotBeChanged"
}
export default Team
